import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface ModalTextProps {
  marginTop?: number;
  marginBottom?: number;
}

const ModalText = styled.p<ModalTextProps>`
  width: 100%;
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  font-size: ${toRem(13.75)};
  line-height: 125%;
  text-align: center;
  color: ${theme.color.neutral[800]};

  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: ${toRem(marginTop)};
    `}

  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: ${toRem(marginBottom)};
    `}
`;

export default ModalText;
